import React from "react";
import classes from "./AppLayout.module.css";

const AppLayout = ({ children }) => {
  return <div className={`${classes.app} App`}>{children}</div>;
};

export default AppLayout;
